// Resizes any crest image source (data URL) down to a small JPEG data URL.
// The crest only ever prints at ~20mm on the page, and it gets embedded into
// up to two PDFs whose base64 both live on the same quoteLetterRequests
// Firestore doc — PNG compresses badge/photo-style crests poorly, so a
// "downscaled" PNG can still be large enough to push that doc past
// Firestore's 1MB limit once it's embedded twice. JPEG at this size is
// visually indistinguishable at print size and a fraction of the bytes.
export function resizeCrestToJpegDataUrl(source, maxDim = 300, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        const scale = maxDim / Math.max(width, height);
        width = Math.round(width * scale);
        height = Math.round(height * scale);
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      // JPEG has no transparency channel — fill white first so a
      // transparent-background PNG crest doesn't turn black.
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    img.onerror = reject;
    img.src = source;
  });
}
